import { render } from "./Test.component.html?vue&type=template&id=73b5cd62&scoped=true&ts=true&external"
import script from "./Test.component.vue?vue&type=script&lang=ts"
export * from "./Test.component.vue?vue&type=script&lang=ts"

import "./Test.component.scss?vue&type=style&index=0&id=73b5cd62&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b5cd62"]])

export default __exports__